import Flex from '@Resources/styles/flex.scss';
import { LinearProgress } from '@mui/material';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { ProgressState } from '@Data/notifications/Interfaces';
import Styles from '../../Header.scss';

const NotificationProgressIndicator = (props) => {
    const { progress, message, remainingTime, state } = props;

    let infoHtml;
    if (state === ProgressState.PENDING) {
        infoHtml = (
            <React.Fragment>
                <LinearProgress variant="determinate" value={progress} />
                {remainingTime && (
                    <span className={Styles.hNotificationRemainingText}>
                        {remainingTime}
                    </span>
                )}
            </React.Fragment>
        );
    } else {
        let infoText;
        switch (state) {
            case ProgressState.CANCELLED:
                infoText = 'Cancelled';
                break;
            case ProgressState.FAILURE:
                infoText = 'Failed';
                break;
            case ProgressState.SUCCESS:
                infoText = 'Completed';
                break;
        }

        infoHtml = (
            <span className={Styles.hNotificationRemainingText}>
                {infoText}
            </span>
        );
    }

    return (
        <div className={cx(Flex.flex, Flex.column, Flex.grow)}>
            <span className={Styles.hNotificationProgressText}>{message}</span>
            {infoHtml}
        </div>
    );
};

NotificationProgressIndicator.propTypes = {
    message: PropTypes.string,
    progress: PropTypes.number,
    remainingTime: PropTypes.any,
    state: PropTypes.oneOf([
        ProgressState.CANCELLED,
        ProgressState.FAILURE,
        ProgressState.PENDING,
        ProgressState.SUCCESS,
    ]),
};
export default NotificationProgressIndicator;
